import axios from 'axios'
import router from '@/router'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = 
  timeout: 5000 // request timeout
})

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers.token = '2993d55f-8d69-42e5-a2fb-3ad50613af0f'
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  if (response.data.code == 'failure') {
    router.replace({
        path: '/rolesDel'
    })
    // return res
}else if (response.data.code == '4004') {
  router.replace({
    path: '/platformNotifications'
  })
}
  return response;
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default service
